export enum Width {
  BLOCK = 'block',
  AUTO = 'auto',
}
